export enum LocationSortFieldEnum {
  CHARGER_SIZE = "CHARGER_SIZE",
  CITY = "CITY",
  COUNTRY = "COUNTRY",
  ID = "ID",
  NAME = "NAME",
  STREET = "STREET",
  USERS_SIZE = "USERS_SIZE"
}
